/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useState, useRef, useMemo } from 'react'
import { connect } from 'react-redux'
import { DatePicker, Button, Input, message, Upload } from 'antd'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { strCol, numCol, dateCol } from '@integec/grid-tools/lib/cols'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
} from 'core/utils'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
// import R from 'ramda'
import {
  DatePickerContext,
  SpinContext,
  ErrorContext,
  JcTmpErrorContext,
} from 'context'
import {
  getEnvConfig,
  getPermitActions,
  getApiTargetInfo,
  ExportComponent,
} from 'core'
import { CriteriaRow, Title, FullHeightSizer, Content } from 'core/screen-util'
import {
  retrieveOaDaImportData,
  oaDaLmpImportData,
  getAuthorization,
  getCredentials,
} from 'api/pgads.js'
import * as Actions from 'core/EventActions'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
// import moment from 'moment'

const gridHeader = [
  dateCol({
    ident: 'transdate',
    display: 'Trans Date',
    width: 100,
    isFiltered: true,
  }),
  strCol({
    ident: 'pnodeid',
    display: 'PNode Id',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({ ident: 'hour1', display: 'Hour 1', isFiltered: true }),
  numCol({ ident: 'hour2', display: 'Hour 2', isFiltered: true }),
  numCol({ ident: 'hour3', display: 'Hour 3', isFiltered: true }),
  numCol({ ident: 'hour4', display: 'Hour 4', isFiltered: true }),
  numCol({ ident: 'hour5', display: 'Hour 5', isFiltered: true }),
  numCol({ ident: 'hour6', display: 'Hour 6', isFiltered: true }),
  numCol({ ident: 'hour7', display: 'Hour 7', isFiltered: true }),
  numCol({ ident: 'hour8', display: 'Hour 8', isFiltered: true }),
  numCol({ ident: 'hour9', display: 'Hour 9', isFiltered: true }),
  numCol({ ident: 'hour10', display: 'Hour 10', isFiltered: true }),
  numCol({ ident: 'hour11', display: 'Hour 11', isFiltered: true }),
  numCol({ ident: 'hour12', display: 'Hour 12', isFiltered: true }),
  numCol({ ident: 'hour13', display: 'Hour 13', isFiltered: true }),
  numCol({ ident: 'hour14', display: 'Hour 14', isFiltered: true }),
  numCol({ ident: 'hour15', display: 'Hour 15', isFiltered: true }),
  numCol({ ident: 'hour16', display: 'Hour 16', isFiltered: true }),
  numCol({ ident: 'hour17', display: 'Hour 17', isFiltered: true }),
  numCol({ ident: 'hour18', display: 'Hour 18', isFiltered: true }),
  numCol({ ident: 'hour19', display: 'Hour 19', isFiltered: true }),
  numCol({ ident: 'hour20', display: 'Hour 20', isFiltered: true }),
  numCol({ ident: 'hour21', display: 'Hour 21', isFiltered: true }),
  numCol({ ident: 'hour22', display: 'Hour 22', isFiltered: true }),
  numCol({ ident: 'hour23', display: 'Hour 23', isFiltered: true }),
  numCol({ ident: 'hour24', display: 'Hour 24', isFiltered: true }),
  numCol({ ident: 'hour25', display: 'Hour 25', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]

const DayAheadLMP = ({ apiTargetInfo, envConfig, actionPermits }) => {
  const [dayAheadLMPData, setDayAheadLMPData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState(null)
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  // const [impHour, setImpHour] = useState(0)
  // const [impDate, setImpDate] = useState(moment())

  const { setTmpError } = useContext(JcTmpErrorContext)

  const importPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
          Actions.DALMP_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const fetchDayAheadLMPData = () => {
    setSpinning(true)
    retrieveOaDaImportData(apiTargetInfo)({
      date: selectedDate.format('YYYY-MM-DD'),
    }).fork(setError, data => {
      setSpinning(false)
      setDayAheadLMPData(data)
    })
  }

  // const { authGodMode } = envConfig

  const importData = _ => {
    // setSpinning(true)
    oaDaLmpImportData(apiTargetInfo)(
      selectedDate.format('YYYY-MM-DD'),
      '00'
    ).fork(setError, _ => {
      // setSpinning(false)

      message.info('Data is downloading, Please retrieve data after some time')
    })
  }
  const fileProps = {
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/screen-csv-import-file`,
    method: 'POST',
    data: { importType: 'OA_DA_LMP_IO' },
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const GridData = useRef()
  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow>
        <Title
          css={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          Day Ahead LMP
        </Title>

        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
        />

        <Button
          loading={spinning}
          onClick={fetchDayAheadLMPData}
          css={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>

        {importPermission && (
          <Button
            onClick={importData}
            icon="import"
            type="primary"
            style={{ marginLeft: '10px' }}
          >
            Import
          </Button>
        )}

        {importPermission && (
          <Upload
            {...fileProps}
            beforeUpload={_ => setSpinning(true)}
            onChange={data => {
              if (data.file.status === 'done') {
                setSpinning(false)

                if (
                  data.file.response &&
                  data.file.response.restfulStatus &&
                  data.file.response.restfulStatus === 'FAILURE'
                ) {
                  setError(data.file.response)
                } else {
                  if (!isErrorContains(data.file.response))
                    message.success('File imported successfully')

                  // this.setState({ errorData: data.file.response })
                  setTmpError(data.file.response)
                }
              }
              if (data.file.status === 'error') {
                setSpinning(false)
                setError(data.file.response)
              }
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button icon="upload" style={{ marginLeft: '10px' }} type="danger">
              Import File (.csv)
            </Button>
          </Upload>
        )}
        {/* <div
          style={{
            marginLeft: '50px',
            border: '1px solid black',
            // width: '250px',
            padding: '2px',
            display: 'grid',
            gridTemplateColumns: '100px 150px 80px 150px',
            gridGap: '5px',
          }}
        >
          <div
            style={{
              display: 'grid',
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            Import For:{' '}
          </div>

          <DatePicker
            onChange={setImpDate}
            value={impDate}
            format="MM/DD/YYYY"
            allowClear={false}
          />
          <Select onChange={setImpHour} value={impHour}>
            {R.range(1, 25).map(i => (
              <Select.Option value={i - 1} key={i - 1}>
                {i}
              </Select.Option>
            ))}
          </Select>
          
        </div> */}

        <div css={{ flex: '1 1 0px' }} />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          css={{ marginRight: '20px', flex: '0 0 200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <ExportComponent
          getData={
            exportDataComponent
              ? _ => exportDataComponent(GridData, dayAheadLMPData, fuzzyFilter)
              : undefined
          }
          data={dayAheadLMPData}
          headers={gridHeader}
          fileName={`Day Ahead LMP-${selectedDate.format(
            'YYYY-MM-DD HH-mm-ss'
          )}`}
          btnStyle={{ marginRight: '10px' }}
          disabled={dayAheadLMPData.length <= 0}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={230}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Grid
              ref={GridData}
              data={dayAheadLMPData}
              headers={gridHeader}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: true,
                rowHeaderRender,
                height: height - 50,
                width: width - 150,
                headerRowHeight: 30,
              })}
              fuzzyFilter={fuzzyFilter}
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(DayAheadLMP)
